// The React face of song_reload.ts's reload pulse (issue #3265 PR C).
//
// song_reload.ts stays React-free - it is shared with the sequencer, which is a plain class - so
// the useSyncExternalStore wrapper the three loaders need lives here. Reading it subscribes the
// component to the moment the playback gate releases a deferred song reload, which is all the
// loaders need: each one then re-runs its own decision (shouldReloadForHashChange) and, with
// playback now stopped, reloads the song's files in place.

import { useSyncExternalStore } from 'react';
import { getSongReloadPulse, subscribeSongReloadPulse } from './song_reload.ts';

export function useSongReloadPulse(): number {
  return useSyncExternalStore(subscribeSongReloadPulse, getSongReloadPulse, getSongReloadPulse);
}
